import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { startLogin } from "@/components/Footer";
import api from "@/lib/api";
import { CalendarCheck } from "lucide-react";

export async function bookConsultation(navigate, user) {
  if (!user) { startLogin(); return; }
  try {
    const { data } = await api.get("/projects");
    if (data.length) navigate(`/project/${data[0].id}?tab=consult`);
    else navigate("/dashboard");
  } catch {
    navigate("/dashboard");
  }
}

export default function ConsultCTA() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!user) return null;
  if (pathname.startsWith("/vda")) return null;
  return (
    <button data-testid="floating-consult-cta" onClick={() => bookConsultation(navigate, user)}
      aria-label="Book Expert Consultation"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#0E9AC8] hover:bg-[#0B7EA4] text-white pl-4 pr-5 py-3 shadow-xl shadow-[#0E9AC8]/30 transition-all hover:-translate-y-0.5">
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#F5923C] opacity-75 animate-ping" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#F5923C]" />
      </span>
      <CalendarCheck className="h-5 w-5" strokeWidth={1.9} />
      <span className="text-sm font-semibold hidden sm:inline">Book Expert Consultation</span>
    </button>
  );
}
